import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import '../Shared/NotFound.css';

/**
 * Shown instead of bouncing a signed-out visitor to the home page with no
 * explanation. Opens the shared login modal on arrival; they can still go
 * elsewhere if they didn't mean to land here.
 */
const SignInGate = () => {
  const { openLogin } = useAuth();

  useEffect(() => {
    openLogin('login');
  }, [openLogin]);

  return (
    <div className="nf-wrap" role="status">
      <div className="nf-inner">
        <p className="nf-code">Sign in</p>
        <h1 className="nf-title">This page is for people who have an account</h1>
        <p className="nf-body">
          Sign in to continue — or create a free account. Your place on the site
          is waiting right here.
        </p>
        <button
          type="button"
          className="btn btn-primary nf-retry"
          onClick={() => openLogin('login')}
        >
          Sign in
        </button>
        <ul className="nf-links" style={{ marginTop: '1.5rem' }}>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/ourplaces">Our Places — find somewhere near you</Link></li>
        </ul>
      </div>
    </div>
  );
};

export default SignInGate;
